import LatestInsights from "../components/LatestInsights";
import AreaGuide from "../components/AreaGuide";
import DeveloperLogos from "../components/DeveloperLogos";
import OffPlanProjects from "../components/OffPlanProjects";
import FeaturedListings from "../components/FeaturedListings";
import PropertySearch from "../components/PropertySearch";

function Home() {
  return (
    <>
    <div className="th-hero-wrapper hero-1">
      <video id="home-video" preload={""} autoPlay={true} muted={true} loop={true}>
        <source src="assets/img/01.mp4" type="video/mp4" />
      </video>
    </div>
    <PropertySearch />
    <FeaturedListings />
    <div className="about-1-wrapper space overflow-hidden" id="about-sec">
      <div className="container">
        <div className="row align-items-center justify-content-center gy-40 gx-70 ">
          <div className="col-xl-6 fadeinup wow" data-wow-duration="1.5s" data-wow-delay="0.1s">
            <img alt="Blue Water Real Estate team" src="assets/img/srfww.jpg" style={{ borderRadius: "20px" }} />
          </div>
          <div className="col-xl-6">
            <div className="title-area text-left">
              <h4 className="sec-title fadeinup wow" style={{ "fontSize": "24px" }} data-wow-duration="1.5s" data-wow-delay="0.3s">
                A family business with family values
              </h4>
              <h2 className="sec-title fadeinup wow" data-wow-duration="1.5s" data-wow-delay="0.3s">
                Here since the beginning, and here for the long run
              </h2>
              <p className="sec-text fadeinup wow" data-wow-duration="1.5s" data-wow-delay="0.5s">
                Blue Water Real Estate was founded in 2004, close to the very start of the UAE freehold market. More than two decades later, we're still here — still focused on a select number of clients, and still giving the same straightforward advice we always have. We know our clients, we know the market, and we know when to say no. That kind of honesty isn't something a large agency can easily afford. For us, it's the whole point.
              </p>
              <div className="header-button fadeinup wow" data-wow-duration="1.5s" data-wow-delay="0.1s">
                <a href="contact-us" className="th-btn   pill text-white">
                  Say Hello
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DeveloperLogos />
    <OffPlanProjects />
    <AreaGuide />
    <LatestInsights />
    </>
  );
}

export default Home;
